document.addEventListener("DOMContentLoaded", function () {

  const popup = document.querySelector('.newsletter-popup-inner');
  const popupBox = document.querySelector('.newsletter-popup');
  if (!popup) return;

  if (window.location.pathname === "/" && !localStorage.getItem("newsletterPopupClosed")) {
    setTimeout(() => {
      popup.classList.add('popup-open');
      document.body.classList.add('popup-open');
    }, 100);
  }

  document.addEventListener("click", function(e){

    // close button
    if (e.target.closest('.newsletter-close')) {
      closePopup();
    }

    if (popup.classList.contains('popup-open') && !popupBox.contains(e.target)) {
      closePopup();
    }

  });

  function closePopup(){
    popup.classList.remove('popup-open');
    document.body.classList.remove('popup-open');
    localStorage.setItem("newsletterPopupClosed", "true");
  }

});